<template>
  <div class="coupon-id-list">
    <template v-if="normalizedItems.length">
      <div
        v-for="(item, index) in visibleItems"
        :key="`${item}-${index}`"
        class="coupon-id"
      >
        {{ item }}
      </div>
      <el-button
        v-if="normalizedItems.length > maxVisible"
        type="text"
        size="mini"
        class="view-all"
        @click="dialogVisible = true"
      >
        查看全部
      </el-button>
    </template>
    <span v-else>{{ emptyText }}</span>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      append-to-body
      custom-class="coupon-id-dialog"
    >
      <div v-if="displaySummaryItems.length" class="coupon-summary">
        <div
          v-for="(item, index) in displaySummaryItems"
          :key="`${item.label}-${index}`"
          class="coupon-summary-item"
        >
          <span>{{ item.label }}：</span>
          <strong>{{ formatValue(item.value) }}</strong>
        </div>
      </div>

      <div class="coupon-table-header">
        <span>序号</span>
        <span>{{ itemLabel }}</span>
      </div>
      <div class="coupon-table-body">
        <div
          v-for="(item, index) in normalizedItems"
          :key="`${item}-${index}`"
          class="coupon-table-row"
        >
          <span>{{ index + 1 }}</span>
          <span>{{ item }}</span>
        </div>
      </div>

      <div slot="footer" class="coupon-dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{ closeText }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WelfareCouponIdList',
  props: {
    items: { type: [Array, String, Number], default: () => [] },
    maxVisible: { type: Number, default: 5 },
    dialogTitle: { type: String, default: '全部卡券ID' },
    emptyText: { type: String, default: '-' },
    summaryItems: { type: Array, default: () => [] },
    showCount: { type: Boolean, default: false },
    countLabel: { type: String, default: '卡券数量' },
    countSuffix: { type: String, default: '张' },
    itemLabel: { type: String, default: '卡券ID' },
    closeText: { type: String, default: '关闭' },
    dialogWidth: { type: String, default: '600px' },
  },
  data() {
    return { dialogVisible: false }
  },
  computed: {
    normalizedItems() {
      const value = this.items
      if (Array.isArray(value)) {
        return value
          .map((item) => {
            if (item && typeof item === 'object') return item.couponNo || item.couponId || item.id
            return item
          })
          .filter((item) => item !== null && item !== undefined && item !== '')
          .map(String)
      }
      if (value === null || value === undefined || value === '') return []
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          if (Array.isArray(parsed)) return this.normalizeArray(parsed)
        } catch (e) {
          // 非 JSON 字符串按逗号分隔处理
        }
        return value.split(',').map((item) => item.trim()).filter(Boolean)
      }
      return [String(value)]
    },
    visibleItems() {
      return this.normalizedItems.slice(0, this.maxVisible)
    },
    displaySummaryItems() {
      const items = this.summaryItems
        .filter((item) => item && item.label)
        .map((item) => ({ label: item.label, value: item.value }))
      if (this.showCount) {
        items.push({
          label: this.countLabel,
          value: `${this.normalizedItems.length}${this.countSuffix}`,
        })
      }
      return items
    },
  },
  methods: {
    formatValue(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    normalizeArray(items) {
      return items
        .map((item) => {
          if (item && typeof item === 'object') return item.couponNo || item.couponId || item.id
          return item
        })
        .filter((item) => item !== null && item !== undefined && item !== '')
        .map(String)
    },
  },
}
</script>

<style lang="less" scoped>
.coupon-id {
  line-height: 20px;
  word-break: break-all;
}

.view-all {
  padding: 2px 0 0;
}

.coupon-summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 10px;
  padding: 14px 18px;
  margin-bottom: 20px;
  color: #7d8799;
  background: #f6f8fb;
  border-radius: 6px;
}

.coupon-summary-item {
  display: flex;
  align-items: center;
  line-height: 20px;
}

.coupon-summary-item strong {
  color: #647084;
  font-weight: normal;
}

.coupon-table-header,
.coupon-table-row {
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  min-height: 40px;
  padding: 0 14px;
  color: #7d8799;
}

.coupon-table-header {
  min-height: 44px;
  border-bottom: 1px solid #e8edf3;
}

.coupon-table-body {
  max-height: 320px;
  padding-top: 10px;
  overflow-y: auto;
}

.coupon-table-row {
  border-radius: 6px;
}

.coupon-table-row:nth-child(odd) {
  background: #f6f8fb;
}

.coupon-table-row span:last-child {
  word-break: break-all;
}

.coupon-dialog-footer {
  text-align: center;
}

::v-deep .coupon-id-dialog .el-dialog__header {
  padding: 24px 20px 12px;
  text-align: center;
}

::v-deep .coupon-id-dialog .el-dialog__title {
  color: #303849;
  font-size: 18px;
}

::v-deep .coupon-id-dialog .el-dialog__body {
  padding: 14px 38px 0;
}

::v-deep .coupon-id-dialog .el-dialog__footer {
  padding: 12px 20px 20px;
}

::v-deep .coupon-id-dialog .coupon-dialog-footer .el-button {
  min-width: 96px;
}
</style>
